<template>
    <header class="header inset-x-0 top-0 z-10" :class="{ 'header-scrolled': isScrolled }">
        <nav class="mx-auto flex max-w-7xl items-center justify-between gap-x-6 p-6 lg:px-8" aria-label="Global">
            <div class="flex lg:flex-1">
                <a href="/" class="-m-1.5 p-1.5">
                    <img class="h-8 w-auto" style="height: 50px;" src="@/assets/img/logo1_02.png" alt="" />
                </a>
            </div>
            <div class="hidden lg:flex lg:gap-x-12">
                <a aria-current="page" href="/"
                    class="router-link-active router-link-exact-active text-sm font-semibold leading-6 text-gray-900">产品中心</a>
                <a href="/query" class="text-sm font-semibold leading-6 text-gray-900">授权查询</a>
                <a href="https://download.yishou.shop/help.html"
                    class="text-sm font-semibold leading-6 text-gray-900">帮助中心</a>
                <a href="/AgentList" class="text-sm font-semibold leading-6 text-gray-900">寻找授权商</a>
                <a href="/about" class="text-sm font-semibold leading-6 text-gray-900">关于我们</a>
            </div>
            <div class="flex flex-1 items-center justify-end gap-x-6">
                <a href="/login" class="login-btn">登录</a>
            </div>
            <div class="flex breadcrumb">
                <button type="button" @click="toggleMobileMenu"
                    class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                    style="border: none;">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" aria-hidden="true" class="h-6 w-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"></path>
                    </svg>
                </button>
            </div>
        </nav>
        <!-- 移动端菜单 -->
        <div v-if="isMobileMenuOpen" class="mobile-menu">
            <div class="mobile-menu-content">
                <a href="/" class="mobile-menu-item">产品中心</a>
                <a href="/query" class="mobile-menu-item">授权查询</a>
                <a href="httpns://boke.yishou.shop/index.php/archives/314/" class="mobile-menu-item">帮助中心</a>
                <a href="/AgentList" class="mobile-menu-item">寻找授权商</a>
                <a href="/about" class="mobile-menu-item">关于我</a>
                <div class="mobile-menu-auth">
                    <a href="/login" class="mobile-menu-register">登录</a>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'IndexHeader',
    data() {
        return {
            isMobileMenuOpen: false,
            isScrolled: false,
            lastScrollTop: 0
        }
    },
    methods: {
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },
        handleScroll(event) {
            const st = event.target.scrollTop;
            if (st > this.lastScrollTop) {
                // 向下滚动
                this.isScrolled = true;
            } else {
                // 向上滚动
                this.isScrolled = st > 0;
            }
            this.lastScrollTop = st <= 0 ? 0 : st;
            console.log(this.isScrolled);
        }
    },
    mounted() {
        const mainContent = document.querySelector('.main-content1');
        if (mainContent) {
            mainContent.addEventListener('scroll', this.handleScroll);
        }
    },
    beforeUnmount() {
        const mainContent = document.querySelector('.main-content1');
        if (mainContent) {
            mainContent.removeEventListener('scroll', this.handleScroll);
        }
    }
})
</script>

<style scoped lang="scss">
.header {
    background-color: rgba(255, 255, 255, 0.064);
    backdrop-filter: blur(10px);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    height: 10vh;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    transition: all 0.3s ease;
    z-index: 100;
}

.header-scrolled {
    background-color: rgba(255, 255, 255, 0.5) !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

nav {
    position: relative;
    z-index: 101;
}

.mx-auto {
    margin-left: auto;
    margin-right: auto;
}

.max-w-7xl {
    max-width: 80rem;
}

.items-center {
    align-items: center;
}

.justify-between {
    justify-content: space-between;
}

.gap-x-6 {
    column-gap: 1.5rem;
}

.p-6 {
    padding: 1.5rem;
}

.lg\:px-8 {
    @media (min-width: 1024px) {
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.flex {
    display: flex;
}

.lg\:flex-1 {
    @media (min-width: 1024px) {
        flex: 1 1 0%;
    }
}

.-m-1\.5 {
    margin: -0.375rem;
}

.p-1\.5 {
    padding: 0.375rem;
}

.h-8 {
    height: 2rem;
}

.w-auto {
    width: auto;
}

.hidden {
    display: none;
}

.lg\:flex {
    @media (min-width: 1024px) {
        display: flex;
    }
}

.lg\:gap-x-12 {
    @media (min-width: 1024px) {
        column-gap: 3rem;
    }
}

.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}

.font-semibold {
    font-weight: 600;
}

.leading-6 {
    line-height: 1.5rem;
}

.text-gray-900 {
    color: #111827;
    font-size: 17px;
}

.login-btn {
    background-color: #4f46e5;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    white-space: nowrap;
}

.breadcrumb {
    display: none;
}

@media (max-width: 640px) {
    .breadcrumb {
        display: block;
        padding: 0;
        margin-left: 1rem;
        margin-bottom: 0;
    }

    .breadcrumb button {
        padding: 0.5rem;
        background: transparent;
        border: none;
        cursor: pointer;
    }

    .breadcrumb svg {
        width: 1.5rem;
        height: 1.5rem;
    }
}

.mobile-menu {
    position: fixed;
    top: 6rem;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 102;
    display: none;
}

@media (max-width: 640px) {
    .mobile-menu {
        display: block;
    }

    .mobile-menu-content {
        background-color: white;
        padding: 1rem;
        animation: slideDown 0.3s ease-out;
        position: relative;
        z-index: 103;
    }

    .mobile-menu-item {
        display: block;
        padding: 1rem;
        color: #374151;
        text-decoration: none;
        border-bottom: 1px solid #e5e7eb;
        font-weight: 500;

        &:hover {
            background-color: #f3f4f6;
        }
    }

    .mobile-menu-auth {
        display: flex;
        gap: 1rem;
        padding: 1rem;
        margin-top: 1rem;
        border-top: 1px solid #e5e7eb;
    }

    .mobile-menu-register {
        flex: 1;
        text-align: center;
        padding: 0.5rem;
        background-color: #4f46e5;
        color: white;
        text-decoration: none;
        font-weight: 500;
        border-radius: 0.375rem;

        &:hover {
            background-color: #4338ca;
        }
    }
}

@keyframes slideDown {
    from {
        transform: translateY(-100%);
    }

    to {
        transform: translateY(0);
    }
}
</style>